import api from '../api/apiClient';

const unwrap = (response) => {
  const payload = response?.data ?? response;
  // Backend checklist routes use the standard { success, data } envelope;
  // accept both that shape and an already-unwrapped payload.
  return payload?.success && payload.data !== undefined ? payload.data : payload;
};

const toResult = (response) => {
  const data = unwrap(response);
  if (data?.success === false) {
    return {
      success: false,
      error: data.error || data.message || 'Request failed',
    };
  }
  return { success: true, data };
};

class ImplementationChecklistService {
  async getGlobalUnified(analysisId) {
    try {
      const response = await api.get(`/implementation-checklist/${analysisId}/global-unified`);
      return toResult(response);
    } catch (error) {
      console.error('[ImplementationChecklistService] getGlobalUnified error:', error);
      return { success: false, error: error.message };
    }
  }

  async deleteChecklist(analysisId) {
    try {
      const response = await api.delete(`/implementation-checklist/${analysisId}`);
      return toResult(response);
    } catch (error) {
      console.error('[ImplementationChecklistService] deleteChecklist error:', error);
      return { success: false, error: error.message };
    }
  }

  async generateQuestions(analysisId, payload) {
    try {
      const response = await api.post(`/implementation-checklist/${analysisId}/generate-questions`, payload);
      return toResult(response);
    } catch (error) {
      console.error('[ImplementationChecklistService] generateQuestions error:', error);
      return { success: false, error: error.message };
    }
  }

  async saveResponsesGlobal(analysisId, payload) {
    try {
      const response = await api.post(`/implementation-checklist/${analysisId}/save-responses`, payload);
      return toResult(response);
    } catch (error) {
      console.error('[ImplementationChecklistService] saveResponsesGlobal error:', error);
      return { success: false, error: error.message };
    }
  }

  async saveResponsible(analysisId, payload) {
    try {
      const response = await api.post(`/implementation-checklist/${analysisId}/responsible/save`, payload);
      return toResult(response);
    } catch (error) {
      console.error('[ImplementationChecklistService] saveResponsible error:', error);
      return { success: false, error: error.message };
    }
  }

  async approveResponsible(analysisId, payload) {
    try {
      const response = await api.post(`/implementation-checklist/${analysisId}/responsible/approve`, payload);
      return toResult(response);
    } catch (error) {
      console.error('[ImplementationChecklistService] approveResponsible error:', error);
      return { success: false, error: error.message };
    }
  }
}

const implementationChecklistService = new ImplementationChecklistService();
export default implementationChecklistService;
